import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_HEART: GlameraIconDefinition = {
  name: 'heart',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-heart-body">
      <path class="glm-heart-left" pathLength="1" d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676"></path>
      <path class="glm-heart-right" pathLength="1" d="M12.409 5.824A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-heart-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './heart.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HeartIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_HEART;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
